import { FC, Key } from 'react';
import { Route, RouteProps, Switch, useRouteMatch } from 'react-router-dom';
import { AuthLayout } from '../../common/layouts';
import { LoginForm, NewPassForm, ConfirmPassForm, RecoverPassForm } from './widgets';

type AuthScreenProps = {};

const authRoutes: RouteProps[] = [
  {
    path: '/login',
    component: LoginForm,
  },
  {
    path: '/new-password',
    component: NewPassForm,
  },
  {
    path: '/recover-password',
    component: RecoverPassForm,
  },
  {
    path: '/confirm-password',
    component: ConfirmPassForm,
  },
]

const AuthScreen: FC<AuthScreenProps> = () => {
  let { path: basePath } = useRouteMatch()

  return (
    <AuthLayout>
      <Switch>
        {authRoutes.map(routeConfig => (
          <Route key={routeConfig.path as Key} {...routeConfig} path={`${basePath}${routeConfig.path}`} />
        ))}
      </Switch>
    </AuthLayout>
  );
}

export default AuthScreen;
export {
  AuthScreen,
};